import { useQuery } from "@tanstack/react-query";
import { Link } from "@tanstack/react-router";
import { AppIcon, IconKit, IconPencil, IconShelf, IconTruck, type IconProps } from "@wilco/ui";
import type { ComponentType } from "react";
import { formatNumber, t } from "../i18n.ts";
import { todayQuery } from "./queries.ts";

/** Раздел «Склад»: экраны кладовщика плитками, как на столе. */
export function StockHub() {
  const today = useQuery(todayQuery);
  const d = today.data;
  const queue = d ? d.receipts.length + d.issues.length + d.counts.due.length : null;
  return (
    <div className="page">
      <h1 className="page-title page-title-icon">
        <AppIcon name="stock" size={32} />
        {t("section.stock")}
      </h1>
      <div className="tiles">
        <Link to="/stock/today" className="tile w-cut">
          <TileBody icon={IconTruck} count={queue} title={t("today.title")} />
        </Link>
        <Link to="/stock/shelf" className="tile w-cut">
          <TileBody icon={IconShelf} count={null} title={t("shelf.title")} />
        </Link>
        <Link to="/stock/requests" className="tile w-cut">
          <TileBody icon={IconKit} count={d ? d.issues.length : null} title={t("requests.title")} />
        </Link>
        <Link to="/stock/requests/new" search={{ warehouse: "SER" }} className="tile w-cut">
          <TileBody icon={IconPencil} count={null} title={t("requests.reorder")} />
        </Link>
      </div>
    </div>
  );
}

/** Экран без счётчика: значок крупно на месте числа, ряд плиток ровный. */
function TileBody({ icon: Icon, count, title }: { icon: ComponentType<IconProps>; count: number | null; title: string }) {
  return (
    <>
      {count === null ? (
        <Icon className="tile-glyph" />
      ) : (
        <>
          <Icon className="tile-icon" />
          <span className="tile-count w-num">{formatNumber(count)}</span>
        </>
      )}
      <span className="tile-title">{title}</span>
    </>
  );
}
